import React, { useState } from "react";
import { Box, Menu, MenuItem, Typography } from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { colors, radii } from "../../theme/designTokens";

const flagSrc = langCode => {
  const code = langCode === "en" ? "gb" : langCode;
  return ["gb", "cn", "ru", "es", "sa", "pt"].includes(code) ? `/flags/${code}.png` : `https://flagcdn.com/w20/${code}.png`;
};

export default function LanguageMenu({ langs, activeLangCode, onSelect }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <Box
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          cursor: "pointer",
          bgcolor: colors.white,
          border: `1px solid ${colors.line}`,
          color: colors.ink2,
          borderRadius: radii.full,
          px: 1.25,
          py: 0.6,
          fontSize: 13,
          fontWeight: 700,
          userSelect: "none",
          "&:hover": { bgcolor: colors.primaryLight },
        }}
      >
        <img
          alt={activeLangCode}
          src={flagSrc(activeLangCode || "en")}
          style={{ width: 18, height: 13, borderRadius: 2, objectFit: "cover" }}
        />
        {activeLangCode ? activeLangCode.toUpperCase() : "EN"}
        <KeyboardArrowDownRoundedIcon sx={{ fontSize: 18 }} />
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: radii.md,
            minWidth: 180,
            boxShadow: "0 12px 32px rgba(26,37,48,0.18)",
          },
        }}
      >
        {langs.length > 0 &&
          langs
            .filter((l) => l.active)
            .map((x, i) => (
              <MenuItem
                key={i}
                selected={x.langCode === activeLangCode}
                onClick={() => {
                  onSelect(x);
                  setAnchorEl(null);
                }}
                sx={{
                  gap: 1.25,
                  "&.Mui-selected": {
                    bgcolor: colors.primaryLight,
                    "&:hover": { bgcolor: colors.primaryLight },
                  },
                }}
              >
                <img
                  alt={x.langCode}
                  src={flagSrc(x.langCode)}
                  style={{ width: 20, height: 14, borderRadius: 2, objectFit: "cover" }}
                />
                <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.ink2 }}>
                  {x.langName}
                </Typography>
              </MenuItem>
            ))}
      </Menu>
    </>
  );
}
